webpackJsonp([87192162464282],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FAQ = function FAQ() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      { className: "slice-lg slice--offset-top bg-base-1" },
	      _react2.default.createElement("span", { className: "mask" }),
	      _react2.default.createElement(
	        "div",
	        { className: "container sct-inner" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-7 col-lg-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "py-3 text-center text-md-left" },
	              _react2.default.createElement(
	                "h1",
	                { className: "heading heading-1 c-white strong-400 text-normal" },
	                "Frequently Asked Questions"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "slice sct-color-2" },
	      _react2.default.createElement(
	        "div",
	        { className: "container container-sm" },
	        _react2.default.createElement("span", { className: "space-xs-lg" }),
	        _react2.default.createElement(
	          "div",
	          {
	            id: "accordionOne",
	            className: "accordion accordion--style-3 accordion-cards--stacked fluid-paragraph",
	            role: "tablist",
	            "aria-multiselectable": "true"
	          },
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "section-title-inner heading-5 text-normal",
	              style: {
	                color: '#008da0'
	              }
	            },
	            "About Us"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "card" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-header", role: "tab", id: "accordionOneHeading-1" },
	              _react2.default.createElement(
	                "h6",
	                { className: "card-title mb-0" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "What Is Your Vision?"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "card-block py-4 px-0" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "We are a tech-enabled premium copywriting service. All the content your company creates should have a goal. We specialize in content that closes the audience and sales gap."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "card" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-header", role: "tab", id: "accordionOneHeading-1" },
	              _react2.default.createElement(
	                "h6",
	                { className: "card-title mb-0" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "Why should we use Jamocha's writers?"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "card-block py-4 px-0" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Our writers are the best in industry. Before working with you, each writer goes through our training course to make sure they are writing content at the industry standard."
	              )
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h3",
	            {
	              className: "section-title-inner heading-5 text-normal",
	              style: {
	                color: '#008da0'
	              }
	            },
	            "LinkedIn Elite Program"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "card" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-header", role: "tab", id: "accordionOneHeading-1" },
	              _react2.default.createElement(
	                "h6",
	                { className: "card-title mb-0" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "What sets Jamocha's LinkedIn program apart from the others?"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "card-block py-4 px-0" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Our network of LinkedIn users and clients. Our network gives us the opportunity to share your content to a wide variety of people."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "card" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-header", role: "tab", id: "accordionOneHeading-1" },
	              _react2.default.createElement(
	                "h6",
	                { className: "card-title mb-0" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "How much does the LinkedIn program cost?"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "card-block py-4 px-0" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Our base rate is $2,000/mo for 4 posts a month (1 post/week). If you would like more posts we charge $1,000/mo for every 4 posts we add a month. (For example: 2 posts/week or 8 posts/mo would be $3,000/mo)."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "card" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-header", role: "tab", id: "accordionOneHeading-1" },
	              _react2.default.createElement(
	                "h6",
	                { className: "card-title mb-0" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "What if I don't have time to answer your weekly questions for content curation?"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "card-block py-4 px-0" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "No worries! We can schedule a call with you instead to get your answers for each question."
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement("span", { className: "space-xs-sm" }),
	    _react2.default.createElement(
	      "section",
	      { className: "slice-sm bg-base-1" },
	      _react2.default.createElement("span", { className: "mask" }),
	      _react2.default.createElement(
	        "div",
	        { className: "container sct-inner" },
	        _react2.default.createElement(
	          "div",
	          { className: "row align-items-center cols-md-space cols-sm-space cols-xs-space" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-9" },
	            _react2.default.createElement(
	              "div",
	              { className: "text-center text-md-left" },
	              _react2.default.createElement(
	                "h1",
	                { className: "heading heading-inverse heading-4 text-normal strong-500" },
	                "We make influencers. Change your life today, and become an influencer."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "text-center text-lg-right" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://jamocha.typeform.com/to/sK6FkT",
	                  className: "btn btn-styled btn-lg btn-white btn-circle"
	                },
	                "Sign Up Today!"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FAQ;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-js-55025e7122ff8014087e.js